import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DialogManager, RouteGuard } from '@patsnap/tahiti-core';
import { VueAutoMountManager } from '@/services/auto-mount/impls/vue-auto-mount-manager';
import { router } from '@/presentation/routers';
import { AutoMountModel } from '@/services/auto-mount/auto-mount-manager';
import { AutoMountModelImpl } from '@/services/auto-mount/impls/auto-mount-model';

export const autoMountModule = new ContainerModule((bind) => {
    bind(DialogManager).to(VueAutoMountManager);
    bind(RouteGuard).toConstantValue(router);
    bind(AutoMountModel).to(AutoMountModelImpl);
});
